<template>
	<br />
  <!-- Main Content Row -->
  <div class="row">
    <!-- Breadcrumbs -->
    <div id="breadcrumbs" class="col-md-3">
      
      <!-- My Hospital View -->
      <div class="row" v-if="store.user.typecode == 'hospital'">
        <div class="col-sm-12 small">
          <hospital 
            :user="store.user"
            :years="store.years"
            :default-year="store.defaultYear"
            :showyear="store.chartType == 'bar' ? true : false"
            ref="myhosp"
					></hospital>
          <br />
        </div>
      </div>
      <!-- Custom groups -->
      <div id="customgroup" class="row">
          <div class="col-sm-12 small">
            <displaygroup v-if="0 in groups"
							index="1"
            	:group="groups[0]"
            	:chart-type="chartType"
            ></displaygroup>
            <displaygroup v-if="1 in groups"
							index="2"
            	:group="groups[1]"
            	:chart-type="chartType"
            ></displaygroup>
            <displaygroup v-if="2 in groups"
							index="3"
            	:group="groups[2]"
            	:chart-type="chartType"
            ></displaygroup>
            <displaygroup v-if="3 in groups"
							index="4"
            	:group="groups[3]"
            	:chart-type="chartType"
            ></displaygroup>
            <displaygroup v-if="4 in groups"
							index="5"
            	:group="groups[4]"
            	:chart-type="chartType"
            ></displaygroup>
          </div>
      </div> 
      <div class="panel panel-default" v-show="store.chartType == 'fdi'">
		    <div class="panel-heading">
		        <h2 class="panel-title">Color Legend</h2>
		    </div>
		    <div class="panel-body text-center" style="padding: 5px;">
		        <p><strong>Risk of Financial Distress</strong></p>
		        <table class="table table-default text-center" style="table-layout: fixed">
		            <tbody>
			            <tr>
			                <td class="darkRedBox" style="width: 20%;"></td>
			                <td class="redBox" style="width: 20%;"></td>
			                <td class="yellowBox" style="width: 20%;"></td>
			                <td class="greenBox" style="width: 20%;"></td>
			                <td class="grayBox" style="width: 20%;"></td>
			            </tr>
			            <tr>
			                <td style="width: 20%; text-align: center; font-size: xx-small">Highest</td>
			                <td style="width: 20%; text-align: center; font-size: xx-small">Mid Highest</td>
			                <td style="width: 20%; text-align: center; font-size: xx-small">Mid Lowest</td>
			                <td style="width: 20%; text-align: center; font-size: xx-small">Lowest</td>
			                <td style="width: 20%; text-align: center; font-size: xx-small">Missing Data</td>
			            </tr>
		          	</tbody>
		        </table>
		    </div>
		</div>
      
      <!-- Buttons --> 
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h2 class="panel-title">Controls</h2>
            </div>
            <div class="panel-body">
                <button type="button" class="btn btn-default btn-block changeIndicator" @click="changeIndicator">
                  Change Indicator
                </button>
              <button id="thebutton" @click="renderVis" class="btn btn-default btn-block">
                Refresh Graph
              </button>      
              <button id="saveCSV" style="display:none;" class="btn btn-default btn-block">
                Save Data as CSV <span class="glyphicon glyphicon-download"></span>
              </button>
              
              <button type="button" class="btn btn-default btn-block" id="saveImage" onclick='savePNG();'>
                Save Image <span class="glyphicon glyphicon-picture" ></span> 
              </button>
              <button type="button" class="btn btn-default btn-block" id="saveImageFD" onclick='saveFDPNG();'>
                Save Image <span class="glyphicon glyphicon-picture" ></span> 
              </button>

              <button v-if="chartType == 'fdi' && store.user.typecode != 'hospital'" name="changeCompGroup" class="btn btn-default btn-block" @click="changeCompGroup">
                Change Comparison group
              </button>
              
              <button name="clearCache" class="btn btn-default btn-block" @click="restart">
                Start new Graph
              </button>
              
              <button type="button" class="btn btn-default btn-block" data-toggle="modal" data-target="#IndicatorData">
                Indicator Definition
              </button>
              <button type="button" class="btn btn-default btn-block" data-toggle="modal" data-target="#MissingData">
                Why is my data missing?
              </button>
              
                  
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Vis container -->
    <div id="vis" name="vis" class="col-md-9 svgContainer" style="background:white;padding-top:5px">
       
    </div>
  </div>
  <br />
  
<!-- Hidden please wait modal -->
<div id="pleaseWait" title="Please Wait..." data-backdrop="static" data-keyboard="false" class="modal">
  <div class="modal-header">Loading the data now</div>
  <div class="modal-body">    
    <div class="progress progress-striped active">
      <div class="progress-bar" style="width: 100%;" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</div>

<!-- Modal for indicator description -->
<div id="IndicatorData" class="modal fade" role="dialog">
  <div class="modal-dialog" id="indicatorDataDialog">
  	<div class="modal-content">
      <div class="modal-header">
      	<h2 class="modal-title">{{ store.selectedIndicator.indicatorString }}</h2>
      </div>
      <div class="modal-body" v-if="store.selectedIndicator.description == ''">
          No data available for {{ store.selectedIndicator.indicatorString }}.
      </div>
      <div class="modal-body" v-else v-html="store.selectedIndicator.description">
      </div>
      <div class="modal-footer">
        <a href="/reporting/indicators/download" class="btn btn-default btn-primary pull-left">Download list of Indicator definitions <span class="glyphicon glyphicon-download"></span></a>
        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal for missing data description -->
<div id="MissingData" class="modal fade" role="dialog">
  <div class="modal-dialog">
  	<div class="modal-content">
      <div class="modal-header">
      	<h2 class="modal-title">Why is my data missing?</h2>
      </div>
      <div class="modal-body">
				<ol>
				    <li>
				        <strong>No Medicare Cost Report:</strong> If a Medicare Cost Report for a particular year is not available, indicator values cannot be calculated. Sometimes there is a substantial delay between a hospital filing its Medicare Cost Report with an intermediary and the Center for Medicare and Medicaid Services releasing the data to researchers and the public.
				    </li>
				    <li>
				        <strong>Invalid Data:</strong>
				         If an account entry is theoretically impossible, then the indicator value is meaningless. For example, a negative number for accumulated depreciation yields a negative average age of plant. Total revenues of zero yields a total margin that is not defined because of division by zero.
				    </li>
				    <li>
				        <strong>Short Fiscal Year:</strong>
				         If a Medicare Cost Report is for a reporting period less than 360 days, indicator values may not be representative of the entire year.
				    </li>
				    <li>
				        <strong>Outliers:</strong>
				        If an indicator value is “very unusual,” there may be a reporting error or other data quality problem. For example, a total margin greater than 100 percent is highly unlikely and probably an error. It is also possible that your hospital has special circumstances that render your indicator as statistically “very unusual” although it is accurate.
				    </li>
				    <li>
				        <strong>Pre-Conversion:</strong>
				        Pre-conversion values of Medicare Outpatient Payer Mix, Medicare Outpatient Cost to Charge, and Medicare Revenue per Day are suppressed because PPS revenue is not comparable to cost-based revenue of CAHs.
				    </li>
				    <li>
				        <strong>New hospital:</strong>
				        We need to wait a couple years after the new hospital is formed before we have sufficient cost report data to begin producing FDI ratings
				    </li>
				</ol>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

</template>



<script setup>
	import { ref, toRaw, watch , nextTick, onActivated} from "vue"; 
	import { storeToRefs } from 'pinia'
	import { useVisualizationsStore } from '../../stores/vis_store'
	import displaygroup from './displaygroup.vue'
	import hospital from './hospital.vue'
	import { onMounted } from 'vue';


	const { fetchHospitals, fetchVisData, loadPage, restart, changeCompGroup, changeIndicator, changeHospitalYear} = useVisualizationsStore()
	const { arrhospitals , chartType, currentPage, loading, years, selectedIndicatorStr, selectedIndicatorId, selectedIndicatorSlug, arrData, params, groups, selectedIndicator} = storeToRefs(useVisualizationsStore())
	var store = useVisualizationsStore()

	var myhosp = ref(null);


	const refreshVis = () => { 
		//store.fetchVisData();
		if ( store.chartType == 'bar' ) {
	    $('#saveImageFD').remove();
	    if ( store.user.typecode == "hospital" ){
	      var vis = new HospitalBarChart();  
	    } else if ( store.user.typecode == "state" ) {
	      var vis = new GovernmentBarChart();
	    } else if ( store.user.typecode == "federal" ) {
	      var vis = new GovernmentBarChart();
	    }
	  } else if ( store.chartType == 'line' ) {
	    $('#saveImageFD').remove();
	    if ( store.user.typecode == "hospital" ){
	      var vis = new HospitalLineChart();  
	    } else if ( store.user.typecode == "state" ) {
	      var vis = new GovernmentLineChart();
	    } else if ( store.user.typecode == "federal" ) {
	      var vis = new GovernmentLineChart();
	    }
	  } else if ( store.chartType == 'fdi' ) {
	    $('#saveImageFD').remove();
	    
	      var vis = new FinancialDistressChart();
	    
	  }


		if ( store.chartType == 'bar' ) {
	    vis.metadata = store.params;
	   vis.benchmark = toRaw(store.arrData[0][0].benchmark);
	   vis.data = toRaw(store.arrData[0]);
	   console.log("visdata");
	   console.log(vis.data);
	   console.log(store.loading + '   loading state');
	   if (typeof store.arrData[0].benchmark !== 'undefined') {
      	if (store.arrData[0].benchmark != 0) {
        	vis.benchmark = store.arrData[0].benchmark;
      	}
     }
	  } else if ( store.chartType == 'line' ) {
	    vis.metadata = store.params;
	   vis.benchmark = toRaw(store.arrData[0][0].benchmark);
	   vis.data = toRaw(store.arrData[0]);
	   console.log("visdata");
	   console.log(vis.data);
	   console.log(store.loading + '   loading state');
	   if (typeof store.arrData[0].benchmark !== 'undefined') {
      	if (store.arrData[0].benchmark != 0) {
        	vis.benchmark = store.arrData[0].benchmark;
      	}
     }
	  } else if ( store.chartType == 'fdi' ) {
	  		vis.metadata = store.params;
	   		//vis.benchmark = toRaw(store.arrData[0][0].benchmark);
	   		vis.data = toRaw(store.arrData[0]);
        // remove refresh, change indicator, saveas png
        $('.changeIndicator').hide(); // new indicator button
        $('#saveImage').remove();
        $('#thebutton').remove();  // refresh button
	  }



	  

		window.vis = vis;
	  

	  
	 
	  $('#saveCSV').show();
	  vis.displaySettings = { "width": $('#vis').width()-30, "height": ( window.innerHeight - 50 ) }; // removing 30 pixels to make charts fit nicer
	  $("#vis").empty();
	  vis.render( document.getElementById("vis") );
	  $(document).trigger(vis.constructor.name+'-render-complete');
	  d3.selectAll('.nvtooltip').remove();
	  $(".tooltip").attr("style", "opacity: 0");
	  // bsWait.hidePleaseWait();
	  setTimeout(() => {  $(".tooltip").attr("style", "opacity: 0"); }, 1000);
	};

	const renderVis = () => {
			store.fetchVisData();
			//setTimeout(function() {
			  $("#div-row-logos").hide();

		}



	


  onMounted(() => {

  	 if (store.user.typecode == 'hospital' )  {
		  	


  	 	watch(
			  () => myhosp.value.myhosp_year,
			  (myhosp_year) => {
			  	
			  	var currentHospYear = parseInt(myhosp.value.myhosp_year)
			  	console.log("vis currentHospYear")
			  	console.log(currentHospYear)
			  	
		    	changeHospitalYear(currentHospYear);
			    nextTick(() => {
			    	renderVis();
			  	});

			  }
			)



		  }
				
        
});


  

watch(arrData, async () => {
    var rawData = toRaw(arrData.value)
    if (  rawData !== undefined && rawData.length > 0 ) {
        //window.alert(arrHospitals.length)
        nextTick(() => {
            refreshVis();
            $('#saveCSV').click(function(){
				          var data = window.vis.data;
				          if(data == '')
				              return;
				          JSONToCSVConvertor(window.vis.dataPrepForCSV(), "CAHMPAS", true);
				      });
        });

    }
  
})

onActivated(() => {
    if (  store.currentPage == 'visualization' ) {
        //window.alert(arrHospitals.length)
        nextTick(() => {
            renderVis();
        });

        $("#div-row-logos").hide();
      window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());

			// gtag('config', '{{ config('app.ga_token') }}');
			 dim4 = "";
			myhospStr = "";
		const query = store.params;
		if ( store.user.typecode == 'hospital' ) {
			if( query.hasOwnProperty("state") ){
		    var dim4 = 'state';
		  }else if ( query.hasOwnProperty("peergroup") ){
		    var dim4 = 'peergroup';
		  }else{
		    var dim4 = 'custom';
		  }
		  var foundHospital = toRaw( store.user.hospitals.find(h => h.year == store.defaultYear) )
			if (foundHospital == null) {
				console.log("getting latest")
				foundHospital = toRaw(store.user.hospitals.at(-1))
			}
			var myHospital = foundHospital;
			console.log("MYHOSP")
			console.log(myhosp)
			myhosp.value.myhosp = myHospital;
		  //const myHospital = toRaw(store.user.hospitals.pop());
		  var myhospStr = myHospital.cahstate;
		}

		if ( query ) {
		  gtag('event', 'show_visualization', {
		        'indicator': query.indicator,
		        'type': query.type,
		        'username': store.user.username,
		        'full_query': JSON.stringify(store.params),
		        'hospital_dimension': dim4,   
		        'hospital_state': myhospStr,
		      });
		}

		    }
  
})

</script>

<style>
  div.tooltip {
  position: absolute;
  text-align: center;
 /* width: 250px;*/
/*  height: 150px;*/
  padding: 5px;
  margin: 5px;
  font: 12px sans-serif;
  background: white;
  border-width: 1px;
  border-radius: 8px;
  border-color: gray;
  pointer-events: none;
}
div.tooltip td{
 
  padding: 3px;
  margin: 2px;
 
}
div.tooltip h3{
 
  padding: 3px;
  margin: 2px;
  font-size: 18px;
  font-weight: bold;
 
}
</style>
